import classnames from "@src/utils/classnames"
import React from "react"
import * as styles from "./box.module.scss"

const Box = ({ children, transitionBg }) => {
  return (
    <div
      className={classnames(styles.box, {
        [styles.transitionBg]: transitionBg,
        is_dark: transitionBg,
      })}
    >
      {children}
    </div>
  )
}

export default Box

export const BoxTitle = ({ children, sub, desc }) => {
  return (
    <div className={styles.title}>
      <h2>
        {children}
        <small>{sub}</small>
      </h2>
      <div className={styles.desc}>{desc}</div>
    </div>
  )
}
